import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo, { breadcrumbLd, faqLd, ogUrl } from "@/components/site/Seo";
import { NETWORK_CITIES } from "@/components/site/PublicPresentation";
import { HowPaid, HOW_PAID_FAQ } from "@/components/site/conversion";

export default function About() {
  return (
    <SiteLayout>
      <Seo
        title="About The Sourcing Atlas — Asian Sourcing & Export House"
        description="The Sourcing Atlas is an independent Asian sourcing & export house, exporting to 30+ countries since 2010, with on-ground partners across China, India, Vietnam and Thailand."
        path="/about"
        ogImage={ogUrl("We buy across Asia. Then we made it a service.", "Who We Are")}
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "About", path: "/about" }]), faqLd([HOW_PAID_FAQ])]}
      />
      <div className="crumb"><Link to="/">Home</Link> › About</div>
      <div className="pband">
        <div className="pband-in">
          <span className="tierpill tn">WHO WE ARE</span>
          <h1>We buy across Asia. Then we made it a service.</h1>
          <p className="lede">Not a travel agency that added sourcing, or an influencer with a services page — a hands-on sourcing & export house that buys across Asia every quarter.</p>
        </div>
      </div>
      <div className="simplepage">
        <h2>The founder story</h2>
        <p>
          The Sourcing Atlas grew out of an Indian export business that has been buying components,
          tooling and machinery across Asia since 2010. Years of that buying — and working
          hand-in-hand with an IATF 16949–certified fastener plant — turned into a repeatable
          playbook, which became the consultancy you see here.
        </p>
        <h2>Quality & verification standard</h2>
        <p>
          Our fastener work runs with an IATF 16949–certified plant — PPAP documentation, material
          certificates and full lot traceability. That discipline is why fasteners are our Tier 1
          category, sourced direct rather than through traders.
        </p>
        <h2>On-ground partners</h2>
        <p>
          Our on-ground partner network covers {NETWORK_CITIES}. Verification,
          inspection and factory visits are coordinated with people who are actually there.
        </p>
        <h2>AI-avatar disclosure</h2>
        <p>
          Our on-screen guide is an AI avatar. The buying team and manufacturing partners are real.
          We disclose this openly because honesty is central to our work.
        </p>
        <div style={{ marginTop: 24 }}><HowPaid /></div>
        <div style={{ marginTop: 20 }}>
          <Link className="btn btn-red" to="/contact">Talk to the team</Link>
        </div>
      </div>
    </SiteLayout>
  );
}
